module.exports = __webpack_public_path__ + "img/detailWx.816785cf.png";